function resetCaptcha() {
    grecaptcha.reset();
}

function subscribeNewsletterCaptcha() {
	const form = $("#subscribe-newsletter").get(0);
	if (form.isValid()) {
		form.submit();
	}
}